import { StyleSheet, Text, View } from '@react-pdf/renderer';
import type { ComponentProps, PropsWithChildren } from 'react';

const styles = StyleSheet.create({
  title: {
    fontSize: 10,
    // fontFamily: 'Helvetica-Bold',
    color: '#2C2D35',
  },
});

export const TableTitle = ({
  children,
  style = {},
  ...props
}: PropsWithChildren<ComponentProps<typeof Text>>) => {
  return (
    <View
      wrap={false}
      style={{
        width: '100%',
        flexDirection: 'row',
        display: 'flex',
        backgroundColor: 'rgb(246,247,249)',
        marginBottom: 7,
        padding: 7,
        borderRadius: 5,
      }}
    >
      <Text
        style={{
          ...styles.title,
          ...(style as any),
        }}
        {...props}
      >
        {children}
      </Text>
    </View>
  );
};
